var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../auth.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Store, Select, Actions, ofActionDispatched } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { Logout, LoginWithBiodigital, CheckProfile, CheckProfileSuccess, LoginWithGoogle, LoginWithFacebook, LoginFailure } from '../../state/auth/auth.actions';
import { AuthState } from '../../state/auth/auth.state';
import { filter, takeUntil } from 'rxjs/operators';
import { CompatibilityService } from 'src/app/shared/compatibility.service';
import { DomSanitizer } from '@angular/platform-browser';
import { GoogleLoginModel } from '../../models/google-login.model';
import { FacebookLoginModel } from '../../models/facebook-login.model';
import { BiodigitalLoginModel } from '../../models/biodigital-login.model';
import { plainToClass } from 'class-transformer';
import { ActivatedRoute } from '@angular/router';
import { StorageService, StorageItemEnum } from 'src/app/shared/storage.service';
var LoginPageComponent = /** @class */ (function () {
    function LoginPageComponent(store, formBuilder, compatibilityService, authService, actions, sanitizer, route, storageService, activatedRoute) {
        this.store = store;
        this.formBuilder = formBuilder;
        this.compatibilityService = compatibilityService;
        this.authService = authService;
        this.actions = actions;
        this.sanitizer = sanitizer;
        this.route = route;
        this.storageService = storageService;
        this.activatedRoute = activatedRoute;
        this.ngUnsubscribe = new Subject();
        this.supportsWegGl = true;
        this.groupConfig = this.authService.getGroupConfigFromRoute(this.route.snapshot);
        // get saved email
        var email = this.storageService.getLocalItem(StorageItemEnum.RememberMeEmail) || '';
        var rememberMe = !!email;
        this.formEmail = this.formBuilder.group({
            'email': [email, [Validators.required, Validators.email]],
            'groupCode': [this.groupConfig.groupCode]
        });
        this.formPassword = this.formBuilder.group({
            'password': ['', Validators.required],
            'rememberMe': [rememberMe]
        });
    }
    Object.defineProperty(LoginPageComponent.prototype, "email", {
        get: function () {
            return this.formEmail.get('email');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginPageComponent.prototype, "password", {
        get: function () {
            return this.formPassword.get('password');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginPageComponent.prototype, "group", {
        get: function () {
            return this.activatedRoute.snapshot.queryParams.group;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginPageComponent.prototype, "code", {
        get: function () {
            return this.activatedRoute.snapshot.queryParams.code;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginPageComponent.prototype, "group_invite", {
        get: function () {
            return this.activatedRoute.snapshot.queryParams.group_invite;
        },
        enumerable: true,
        configurable: true
    });
    LoginPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.store.dispatch(new CheckProfileSuccess(null));
        this.profileCheck$.pipe(filter(function (profileCheck) { return profileCheck != null; }), takeUntil(this.ngUnsubscribe)).subscribe(function (profileCheck) {
            if (!profileCheck.isUser) {
                _this.handleUserNotFound();
            }
        });
        this.actions.pipe(ofActionDispatched(LoginFailure), takeUntil(this.ngUnsubscribe)).subscribe(function (action) {
            _this.handleLoginFailure(action.error);
        });
        this.supportsWegGl = this.compatibilityService.supportsWebGl();
        // track remember me
        this.formPassword.get('rememberMe').valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (rememberMe) {
            if (rememberMe && _this.formEmail.valid) {
                _this.storageService.setLocalItem(StorageItemEnum.RememberMeEmail, _this.formEmail.value.email);
            }
            else {
                _this.storageService.removeLocalItem(StorageItemEnum.RememberMeEmail);
            }
        });
    };
    LoginPageComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    LoginPageComponent.prototype.handleBackClick = function () {
        this.store.dispatch(new CheckProfileSuccess(null));
        this.errorMessage = '';
    };
    LoginPageComponent.prototype.handleGoogleClick = function () {
        var _this = this;
        this.authService.authenticateWithGoogle()
            .then(function (value) {
            var login = plainToClass(GoogleLoginModel, __assign({}, new GoogleLoginModel(value.idToken), _this.groupConfig));
            _this.store.dispatch(new LoginWithGoogle(login));
        })
            .catch(function () { });
    };
    // Deprecated
    LoginPageComponent.prototype.handleFacebookClick = function () {
        var _this = this;
        this.authService.authenticateWithFacebook()
            .then(function (value) {
            var login = new FacebookLoginModel(value.authToken);
            _this.store.dispatch(new LoginWithFacebook(login));
        })
            .catch(function () { });
    };
    LoginPageComponent.prototype.handleEmailSubmit = function () {
        this.submitEmail();
    };
    LoginPageComponent.prototype.handlePasswordSubmit = function () {
        this.errorMessage = '';
        this.submitPassword();
    };
    LoginPageComponent.prototype.handleLogout = function () {
        this.store.dispatch(new Logout());
    };
    LoginPageComponent.prototype.handleLoginFailure = function (error) {
        var message = error.error.error.message || 'There was an error signing in.';
        this.errorMessage = this.sanitizer.bypassSecurityTrustHtml(message);
    };
    LoginPageComponent.prototype.handleUserNotFound = function () {
        var message = "\n      <div class=\"text-12 text-medium\">Account not found</div>\n    ";
        this.errorMessage = this.sanitizer.bypassSecurityTrustHtml(message);
    };
    LoginPageComponent.prototype.submitEmail = function () {
        this.errorMessage = '';
        if (this.formEmail.valid) {
            var email = this.formEmail.get('email').value;
            this.store.dispatch(new CheckProfile(email));
        }
    };
    LoginPageComponent.prototype.submitPassword = function () {
        if (this.formPassword.valid) {
            var login = new BiodigitalLoginModel(this.formEmail.get('email').value, this.formPassword.get('password').value, this.formPassword.get('rememberMe').value);
            login = __assign({}, login, this.groupConfig);
            login.groupCode = this.formEmail.get('groupCode').value;
            this.store.dispatch(new LoginWithBiodigital(login));
        }
    };
    __decorate([
        Select(AuthState.getProfileCheck),
        __metadata("design:type", Observable)
    ], LoginPageComponent.prototype, "profileCheck$", void 0);
    __decorate([
        Select(AuthState.getLoading),
        __metadata("design:type", Observable)
    ], LoginPageComponent.prototype, "loading$", void 0);
    return LoginPageComponent;
}());
export { LoginPageComponent };
